export const CONTACT = {
  phones: [
    { label: "+91 70969 30044", raw: "917096930044" },
    { label: "+91 82383 84601", raw: "918238384601" },
  ],
  /** The number every WhatsApp entry point routes to. */
  whatsApp: "917096930044",
  email: "durgastra.innovations@gmail.com",
  address:
    "iHub Gujarat, KCG Campus, opp. PRL, nr. LD College of Engineering, Navrangpura, Ahmedabad, Gujarat 380015",
} as const;

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "solutions", label: "Solutions" },
  { id: "about", label: "About Us" },
  { id: "products", label: "Products" },
  { id: "capabilities", label: "Capabilities" },
  { id: "careers", label: "Careers" },
  { id: "contact", label: "Contact" },
] as const;

export const NAV_IDS = NAV_LINKS.map((link) => link.id);
